import { useContext } from 'react';
import { Space, Divider, Flex, Tooltip, Button, Card } from 'antd';
import { MoonOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { UserContext, ThemeContext } from '@/state/contexts';
import { MFASetup } from '@/features/mfa';
import iCardioLogoLight from '@/images/icardio-logo-light.svg';
import iCardioLogoBlack from '@/images/icardio-logo-dark.svg';
import styles from './MFASetupPage.module.css';

const MFASetupPage = () => {
  const { setUser } = useContext(UserContext);
  const { darkTheme, setDarkTheme } = useContext(ThemeContext);
  const navigate = useNavigate();

  const clearSessionAndRedirect = () => {
    // Clear the pre-MFA session — the backend requires a token issued
    // after MFA verification, so the user must log in again.
    localStorage.removeItem('AccessToken');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/login');
  };

  return (
    <div className={styles.pageContainer}>
      <Flex vertical wrap gap="middle">
        <Flex justify="end">
          <Tooltip title="Change theme config" placement="top">
            <Button
              icon={<MoonOutlined />}
              onClick={() => setDarkTheme(!darkTheme)}
            />
          </Tooltip>
        </Flex>

        <Card className={styles.card}>
          <Space
            orientation="vertical"
            className={styles.logoWrapper}
            size={24}
          >
            <img
              className={styles.logo}
              src={darkTheme ? iCardioLogoLight : iCardioLogoBlack}
              alt="iCardio.ai"
            />
          </Space>
          <Divider size="large" />
          <MFASetup
            onComplete={clearSessionAndRedirect}
            onCancel={clearSessionAndRedirect}
          />
        </Card>
      </Flex>
    </div>
  );
};

export default MFASetupPage;
